<p>
  Методът на потвърждение е начинът, по който удостоверявате, че желаете да извършите дадено действие в платформата –
  например <strong>покупка</strong> или <strong>участие в наддаване</strong>.
</p>
<p>
  По подразбиране се използва потвърждение чрез <strong>въвеждане на парола</strong>, което гарантира висока сигурност и
  предпазва от неволни действия или злоупотреби. При нужда, може да изберете друг предпочитан метод.
</p>
<h6 class="mt-3">Възможни методи за потвърждение:</h6>
<ul>
  <li><strong>С парола</strong> – ще въвеждате текущата си парола при всяко потвърждение. Това е <strong>препоръчителният</strong>
    и най-сигурен вариант.
  </li>
  <li><strong>С ПИН код</strong> – вместо парола, ще използвате кратък ПИН код, който сами задавате.
  </li>
  <li><strong>Без потвърждение</strong> – действията се извършват без въвеждане на парола или ПИН. <strong>Не се
    препоръчва</strong>, особено при споделени или незащитени устройства.
  </li>
</ul>
<h6 class="mt-3">Как да смените метода:</h6>
<ol>
  <li>Отидете на <strong>„Профил“</strong> → <strong>„Настройки“</strong>.</li>
  <li>В секцията <strong>„Настройки на профила“</strong> изберете <strong>„Промени“</strong> до реда <strong>„Метод за
    потвърждение“</strong>.
  </li>
  <li>Изберете желания метод, въведете текущата си парола (и ПИН, ако е приложимо), след което натиснете <strong>„Запази“</strong>.
  </li>
</ol>
<h6 class="mt-3">Какво следва?</h6>
<p>
  Новият метод ще бъде приложен незабавно. При следваща покупка, наддаване или друга защитена операция, ще се използва
  новият избран начин на потвърждение.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Ако често използвате мобилно устройство, потвърждението с ПИН код може да бъде по-удобно и
  също толкова сигурно. Избягвайте пълното деактивиране на защитата, освен ако сте сигурни в сигурността на устройството
  си.
</div>
